import React from 'react'
import * as h from "../../helpers/helpers";
import { lu } from '../../data/reportData';
import { TAB, H1, H2, TXR_B, TXR_I, TXR_II, TXC_I, CK1 } from "../../styles/urar-styles";
import { COMMENTARY, EXHIBITS, TABLE } from "../../styles/urar-styles";
import { ADDD } from './ADDD';

export function UNIT_INTERIORS({dwelling}) {
	//console.log("UIS: ", dwelling);

	var puList = dwelling.propertyUnits;
	if (puList.length === 0) return undefined;

	return (
		<>
		{
			puList.map((pu, pi) => {
				return (<UNIT_INTERIOR key={pi} dwelling={dwelling} propertyUnit={pu} />)
			})			
		}
		</>
	)

}

export function UNIT_INTERIOR({dwelling, propertyUnit}) {
	//console.log("UI: ", dwelling, propertyUnit);

	global.ptr.subDwelling = dwelling;
	global.ptr.propertyUnit = propertyUnit;
	global.ptr.unitDetail = propertyUnit.propertyUnitDetail;
	global.ptr.propertyUnitArea = propertyUnit.propertyUnitArea;

	var heading = "Unit Interior";
	//console.log(dwelling.improvementDetail.improvementType, global.ptr.subDetail.livingUnitExcludingADUCount);

	if (dwelling.improvementDetail.improvementType === "Dwelling" && global.ptr.subDetail.livingUnitExcludingADUCount > 1) {
		heading += " - " + dwelling.structure.structureDetail.structureIdentifier;
	}	else if (dwelling.improvementDetail.improvementType === "Outbuilding") {
		heading += " - " + h.toEnumText(dwelling.improvementDetail.outbuildingType);
	}

	if (global.ptr.subDetail.livingUnitExcludingADUCount > 1 || global.ptr.subDetail.accessoryDwellingUnitTotalCount > 0) {
		heading += " - " + propertyUnit.propertyUnitDetail.unitIdentifier;
	}


	return (
		<>
			<TAB title={heading} />
			<div className='col2 mt-3'>
				<div>
					<TXR_B title="Area Breakdown" value=" " />
					<TXR_I title="Finished Above Grade" value={lu("10.003")} />
					<TXR_I title="Finished Above Grade (Nonstandard)" value={lu("10.004")} />
					<TXR_I title="Unfinished Above Grade" value={lu("10.005")} />
					<TXR_I title="Finished Below Grade" value={lu("10.006")} />
					<TXR_I title="Finished Below Grade (Nonstandard)" value={lu("10.007")} />
					<TXR_I title="Unfinished Below Grade" value={lu("10.008")} />
					<TXR_B title="Area Data Source" value={lu("10.009")} />
					<TXR_B title={"Below Grade Finish Compared\nto Above"} value={lu("10.010")} />
					{ global.ptr.subProp.accessoryDwellingUnitTotalCount > 0 &&
						<>
						<CK1 title="ADU" value={lu("10.011")} yn />
						<TXR_I title="Legally Rentable" value={lu("10.012")} />
						<TXR_II title="Data Source" value={lu("10.013")} />
						<TXR_I title="Typical for Market" value={lu("10.014")} />
						<TXR_I title="Ingress/Egress" value={lu("10.015")} />
						<TXR_I title="Separate Postal Address" value={lu("10.016")} />
						</>
					}
				</div>
				<div>
					<TXR_B title="Levels in Unit" value={lu("10.017")} />
					<TXR_B title="Floor Number" value={lu("10.018")} />
					<TXR_B title="Corner Unit" value={lu("10.019")} />
					<TXR_B title="Occupancy" value={lu("10.020")} />
					<TXR_B title="Utilities Separately Metered" value={lu("10.021")} />
					<TXR_B title="Utilities Operating" value={lu("10.022")} />
					<TXR_B title="Total Bedrooms" value={lu("10.023")} />
					<TXR_B title="Total Bathrooms - Full" value={lu("10.024")} />
					<TXR_B title="Total Bathrooms - Half" value={lu("10.025")} />
					<TXR_B title="Non-Residential Use in Unit" value={lu("10.026")} />
					<TXR_B title="Live/Work Space" value={lu("10.027")} />
					<TXR_I title="Allowable Work Space" value={lu("10.028")} />
				</div>
			</div>

			<H2 title="Level and Room Detail" />
			<TABLE titles={["Level in Unit","Grade Level Detail","Finish","Area","Room Summary"]} widths={[216, 216, 216, 216, 216]} values={lu("10.029-33")} fmt53 />

			<H1 title="Quality and Condition" />
			<div className='col2 mt-3'>
				<div>
					<TXR_B title="Interior Quality Rating" value={lu("10.034")} />
				</div>
				<div>
					<TXR_B title="Interior Condition Rating" value={lu("10.035")} />
				</div>
			</div>

			<TXC_I comment="The tables below support the Interior Quality and Condition ratings and reflect the market value condition of this report" />
			<H2 title="Kitchen and Bathroom Details" />
			<TABLE titles={["Room","Update Status","Time Frame","Quality Comment","Condition Status","Condition Comment"]} widths={[180,180,180,180,180,180]} values={lu("10.037-42")} />
			
			<div className='col2 mt-3'>
				<div>
					<TXR_B title="Overall Update Status for Bathrooms" value={lu("10.043")} />
				</div>
				<div>
				</div>
			</div>
			<H2 title="Interior Features" />
			<TABLE titles={["Feature","Detail","Quality Comment","Condition Status","Condition Comment"]} widths={[216, 216, 216, 216, 216]} values={lu("10.044-48")} />
			<div className='col2 mt-3'>
				<div>
					<TXR_B title="Overall Update Status for Flooring" value={lu("10.049")} />
				</div>
				<div>
				</div>
			</div>

			<TABLE h1="Accessibility Features for Individuals with Disabilities" titles={["Feature","Comment"]} widths={[190, 950]} values={lu("10.050-51")} />

			<ADDD values={lu("10.056-60")} subtitle="(Unit Interior)" /> 

			<COMMENTARY title="Unit Interior Commentary" value={lu("10.061")} />

			<EXHIBITS title="Unit Interior Exhibits" values={lu("10.099")} />
		</>
	)
}
